import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { AgendamentosService } from 'src/app/services/agendamentos.service';
import { ParametrosService } from 'src/app/services/parametros.service';
import { ServerUrlService } from 'src/app/services/server-url.service';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'app-associar-paciente',
  templateUrl: './associar-paciente.component.html',
  styleUrls: ['./associar-paciente.component.scss']
})
export class AssociarPacienteComponent implements OnInit {

  // usuario id, mas com esse nome pois já estava assim
  @Input() pacienteID: number;

  displayedColumns: any;
  dataSource: any = [];

  agendamento: any = {};
  paciente: any = {};
  pacientesOtimus: any = {};

  loadAgendamentoCompleted: boolean;
  loadPacienteCompleted: boolean;
  loadPacOtimusCompleted: boolean;

  smallScreen: boolean;
  appVet: boolean = false;

  constructor(
    private agendamentoServico: AgendamentosService,
    private tools: ToolsService,
    private breakpointObserver: BreakpointObserver,
    private parametroService: ParametrosService,
  ) {
  }

  ngOnInit() {
    this.carregarPaciente();

    this.smallScreen = (window.innerWidth <= 400) ? true : false;
      this.breakpointObserver.observe([
        Breakpoints.XSmall,
        Breakpoints.Small
      ]).subscribe(result => {
        this.smallScreen = result.matches;
      });

      const appVetParam = this.parametroService.getParams('APP_VET')
      this.appVet = appVetParam && appVetParam.valor === 'true' ? true : false

    this.displayedColumns = ['full'];
  }

  carregarPaciente() {
    this.loadPacienteCompleted = false;
    this.agendamentoServico.buscaPacienteSemToken(this.pacienteID)
      .subscribe(
        (response: any) => {
          this.paciente = response.body;
          this.paciente.datanascBr = this.tools.dateToStringBr(this.paciente.nascimento);
          if ( this.paciente.vet) {
            this.paciente.vet.dataBr = this.tools.dateToStringBr(this.paciente.vet.idade);
          }
          this.loadPacienteCompleted = true;
          this.carregarPacienteOtimus();
        },
        (err) => {
          console.error('Err Carregar', err)
          this.loadPacienteCompleted = true;
        }
      );
  }

  carregarPacienteOtimus() {
    this.loadPacOtimusCompleted = false;
    const pac = this.paciente;
    pac.datanasc = this.tools.dateToDataBaseString(this.paciente.nascimento);
    this.agendamentoServico.buscaPacienteOtimusSemToken(pac)
      .subscribe(
        (response: any) => {
          this.pacientesOtimus = response.body;
          this.pacientesOtimus.forEach(element => {
            this.dataSource.push(
              {
                id: element.id,
                nome: element.nome,
                email: element.email,
                celular: element.celular,
                cpf: element.cpf,
                datanasc: this.tools.dateToStringBr(element.datanasc),
                appvet: this.appVet,
                tutor: element.nomemae,
                tutornasc: element.vetidade ? this.tools.dateToStringBr(element.vetidade) : ''
              });
          });
          this.loadPacOtimusCompleted = true;
        }
      );
  }

  vincularPacienteOtimus(integracaoId: number) {
    this.agendamentoServico.vincularPacienteOtimusSemToken(this.paciente.id, integracaoId)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            const newPaciente = response.body;
            if (newPaciente) {
              this.paciente.integracao_id = newPaciente.integracao_id;
              this.paciente.pacienteOtimus = newPaciente.pacienteOtimus;
            } else {
              alert('Ocorreu um erro interno. Tente novamente.');
            }
          } else {
            alert('Ocorreu um erro interno. Tente novamente.');
          }
        },
        (err) => alert('Ocorreu um erro interno. Tente novamente.')
      );
  }

  novoOuDesvincularPac() {
    if (this.paciente.integracao_id) {
      this.dataSource = [];
      this.carregarPacienteOtimus();
      // Devincular Paciente
      this.vincularPacienteOtimus(null);
    } else {
      // Criar paciente Novo
      const body: any = {
        id: this.paciente.id,
        nome: this.paciente.nome,
        datanasc: this.tools.dateToDataBaseString(this.paciente.nascimento),
        cpf: this.paciente.cpf,
        email: this.paciente.email,
        celular: this.paciente.fone,
        convenio: null,
        plano: null,
        cep: this.paciente.cep,
        estado: this.paciente.estado,
        cidade: this.paciente.cidade,
        logradouro: this.paciente.logradouro,
        numero: this.paciente.numero ? this.paciente.numero : 0,
        complemento: this.paciente.complemento,
        bairro: this.paciente.bairro,
        referencia: this.paciente.referencia,
        responsaveis: this.paciente.responsaveis,
        sexo: this.paciente.sexo,
        nome_social: this.paciente.nome_social,
        peso: this.paciente.peso,
        validade_carteirinha: this.agendamento.validade_carteirinha || ''
      };

      if (this.paciente.vet && this.paciente.vet.nome) {
        body.vet = this.paciente.vet
      }

      this.agendamentoServico.criarPacienteOtimusSemToken(body)
        .subscribe(
          (response: any) => {
            const newPaciente = response.body;
            if (newPaciente) {
              this.paciente.integracao_id = newPaciente.integracao_id;
              this.paciente.pacienteOtimus = newPaciente.pacienteOtimus;
            }
          },
          (err) => alert('Ocorreu um erro interno. Tente novamente')
        );
    }
  }
}
